module.exports = __webpack_public_path__ + "img/particle_motion_00112.8e028129.png";